import { AbstractBluetoothAdapter } from './AbstractBluetoothAdapter';
import { VelocityBluetoothAdapter } from './VelocityBluetoothAdapter';
import { CrossFrameBluetoothAdapter } from './CrossFrameBluetoothAdapter';
import { EnvironmentDetail } from '@src/utils';

/**
 * Determines which bluetooth adapter / implementation to use based off platform
 */
export class BluetoothAdapterProvider {
    private static instance: AbstractBluetoothAdapter;

    public static get(): AbstractBluetoothAdapter {
        if (!BluetoothAdapterProvider.instance) {
            if (EnvironmentDetail.isVelocityBrowser(window)) {
                console.log('ATBase: Velocity Browser detected, using VelocityBluetoothAdapter');
                BluetoothAdapterProvider.instance = new VelocityBluetoothAdapter();
            } else {
                console.log('ATBase: Using CrossFrameBluetooth');
                BluetoothAdapterProvider.instance = new CrossFrameBluetoothAdapter();
            }
        }
        return BluetoothAdapterProvider.instance;
    }
}
